import React from 'react';
import { Tooltip } from '@material-ui/core';
import moment from 'moment';

export const nombresAccion = {
  Descarga: 'Descargado',
  Mail: 'Enviado por mail',
  Whatsapp: 'Enviado por WhatsApp'
};

export const nombreAccion = (accion) => nombresAccion[accion.accion] || accion.accion;

/** "28/10/2026 11:05 · Juan Pérez" */
export const detalleAccion = (accion) =>
  `${moment(accion.fecha).format('DD/MM/YYYY HH:mm')}${accion.usuario ? ` · ${accion.usuario}` : ''}`;

/** Lo último que se hizo con el comprobante desde Impresión: acción, fecha y usuario (y los destinatarios en el tooltip). */
const UltimaAccionImpresion = ({ ultimaAccion }) => {
  if (!ultimaAccion) return null;

  const accion = (
    <div>
      <div>{nombreAccion(ultimaAccion)}</div>
      <div style={{ color: 'gray', fontSize: '11px' }}>{detalleAccion(ultimaAccion)}</div>
    </div>
  );

  return ultimaAccion.destinatarios ? <Tooltip title={`Enviado a: ${ultimaAccion.destinatarios}`}>{accion}</Tooltip> : accion;
};

export default UltimaAccionImpresion;
